import type {ParameterDefinitionType} from '@volkswagen-onehub/vw-starter-framework';

export interface BffProcessEnv {
  SERVICE_CONFIG_USERNAME: string;
  SERVICE_CONFIG_PASSWORD: string;
  LOCAL_MOCKS_BASE_URL?: string;
  MOCKS_PASSWORD: string;
  MOCKS_USERNAME: string;
  ONEHUB_USERNAME: string;
  ONEHUB_PASSWORD: string;
}

export const bffEnvVariablesDefinition: ParameterDefinitionType<BffProcessEnv> =
  {
    SERVICE_CONFIG_PASSWORD: {
      required: true,
      description: 'Password to access the service config enpoint service.',
    },
    SERVICE_CONFIG_USERNAME: {
      required: true,
      description: 'Username to access the service config enpoint service.',
    },
    LOCAL_MOCKS_BASE_URL: {
      required: false,
      description:
        'To enable a local mock server use this variable (e.g. https://localhost:5001)',
    },
    MOCKS_PASSWORD: {
      required: true,
      description: 'Password to access the mock server',
    },
    MOCKS_USERNAME: {
      required: true,
      description: 'Username to access the mock server',
    },
    ONEHUB_PASSWORD: {
      required: true,
      description: 'Password to access model-structure on ca prod',
    },
    ONEHUB_USERNAME: {
      required: true,
      description: 'Username to access model-structure on ca prod',
    },
  };
